import {
  RESET_UI_STATE,
  STR_MUTATION_FULLSCREEN_LOADING,
  SHOW_FORGOT_PASSWORD_DIALOG,
  SHOW_ADD_CHILDREN_TO_ORDER_DIALOG
} from "./mutation-types";
import { getDefaultState } from "@/vuex/modules/ui";
export default {
  // misc
  resetUiState: ({ commit }) => {
    commit(RESET_UI_STATE, getDefaultState());
  },
  setFullScreenLoading: ({ commit }, bLoading) => {
    commit(STR_MUTATION_FULLSCREEN_LOADING, bLoading);
  },
  // other dialogs
  uiShowForgotPasswordDialog: ({ commit }) => {
    commit(SHOW_FORGOT_PASSWORD_DIALOG, true);
  },
  uiHideForgotPasswordDialog: ({ commit }) => {
    commit(SHOW_FORGOT_PASSWORD_DIALOG, false);
  },
  uiShowAddChildrenToOrderDialog: ({ commit }, mode = "new") => {
    commit(SHOW_ADD_CHILDREN_TO_ORDER_DIALOG, mode);
  },
  uiHideAddChildrenToOrderDialog: ({ commit }) => {
    commit(SHOW_ADD_CHILDREN_TO_ORDER_DIALOG, false);
  }
};
